import { render, staticRenderFns } from "./ModeleFlexible.vue?vue&type=template&id=710e52af&"
import script from "./ModeleFlexible.vue?vue&type=script&lang=js&"
export * from "./ModeleFlexible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports